module.exports = __webpack_public_path__ + "img/add-to-cart.62c9cd8.mp3";